import { styled } from '@mui/material/styles'
import { Box, Typography } from '@mui/material'
import { CheckCircle } from '@mui/icons-material'

export const StyledContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
  maxWidth: '600px',
  margin: '0 auto',
  minHeight: '400px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}))

export const StyledSuccessIcon = styled(CheckCircle)({
  fontSize: 64,
})

export const StyledTitle = styled(Typography)({
  textAlign: 'center',
})
